<div class="ident" [attr.data-kind]="kind">
  <img class="ident__avatar" [src]="avatar" [alt]="name" />

  <div class="ident__body">
    <p class="ident__name">{{ name }}</p>

    <div class="ident__tags">
      <span class="ident__kind">
        <i [class]="kindIcon"></i>
        {{ kindLabelKey | translate }}
      </span>

      @if (showLearningPath) {
        <span class="ident__path">
          <i class="fa-solid fa-route"></i>
          {{ learningPath }}
        </span>
      }
    </div>
  </div>
</div>
